/**
 * Formats Wandz data by extracting relevant properties.
 *
 * @param {Object} data - The input data object containing user state and configuration.
 * @param {Object} data.userState - The user state object.
 * @param {boolean} [data.userState.isLoggedIn=false] - Indicates if the user is logged in.
 * @param {Object} [data.config] - The configuration object.
 * @param {*} [data.config.rewardExpiringSoon] - Is true if coupon expires within 14 days
 * @returns {Object|null} An object containing the formatted data or null if input data is not provided.
 */

export const formatWandzData = (data) => {
  if (!data) return null;
  const { rewardExpiringSoon } = data.config || {};

  return {
    ...((rewardExpiringSoon !== undefined) && { rewardExpiringSoon }),
  };
};
